import ctl from '@netlify/classnames-template-literals';

const inputBase = ctl(`w-full
  bg-ghost-white
  border-[1px] 
  border-chinese-silver 
  rounded-[3px] 
  py-[6px] 
  px-2`);

export default {
  inputBase,
};
